import type { QueryFunctionContext, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ExtensionGovernanceUsersResponse } from "../../types";
import { extensionSettingsQueryKeys } from "../key-factory/factory";

export const useExtensionGovernanceUsersQuery = (): UseQueryResult<ExtensionGovernanceUsersResponse> => {
    return useQuery({
        queryKey: extensionSettingsQueryKeys.governanceUsers(),
        queryFn({ signal }: QueryFunctionContext): Promise<ExtensionGovernanceUsersResponse> {
            return salesApiService.extensionManagement.fetchGovernanceUsers({ cancellation: signal });
        },
    });
};
